import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import layout from '@/views/layout'
import { getToken } from '@/utils/auth'
import { getLanguage } from "@/i18n/i18n.js"; 
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'// Progress 进度条样式
const _import = require('./_import_' + process.env.NODE_ENV);
Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: _import('/login'),
      meta: {
        noAuth: true
      }
    },
    { 
      path:'/index',
      component:_import('/index/index')
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  store.dispatch('initSysConfig').then(()=>{
    /* 判断要访问的路由是否需要权限访问 */
    if( to.meta && to.meta.noAuth ){
      next()
    }else{
      /* 判断是否有sessionId */
      //if( store.getters.hasSession ) {
      //暂时处理hasSession有时返回false的bug
      if( getToken() ? true : false ) {
        /* 判断是否已读取用户信息 */
        if( store.getters.hasUserInfo ) {
          next()
        }else {
          /* 获取用户信息 */
          store.dispatch('getUserInfo').then( res => {
            // console.log('getUserInfo', res)
            //newRouters.push( { path: '*', redirect: '/404', hidden: true } )
            //router.options.routes.push(...newRouters)

            let menuList = res.data.menu
            
            // console.log('menuList',menuList)
            const lang = getLanguage()
            let menuRouters = [] 
            /*先取出模块，没有父id的就是模块菜单*/
            menuList.forEach((m,i)=>{
              if(m.parent_id==0){
                
                const path = m.path
                let fullPath = m.path
                let children = [
                  {
                    path:'',
                    name: m.name,
                    component:_import(path),
                    meta:{
                      menuHide: true,
                      title: m.title
                    }
                  }
                ]
                if(m.children&&m.children.length){
                  for(let i=0; i<m.children.length; i++){
                    const subPathStr = m.children[i].path
                    const subPathArr = subPathStr.split('/');
                    const subPath = subPathArr[subPathArr.length - 1];
                    
                    
                    let child_menu_name = m.children[i].menu_name
                    if(lang=='en-US'||lang=='en'){
                      child_menu_name = m.children[i].en_name
                    }
                    children.push({
                      name: child_menu_name,
                      path: subPath,
                      component: _import(m.children[i].component),
                      meta:{ id:m.children[i].id, title: child_menu_name, fullPath: m.children[i].path}
                    })
                  }
                  if(children.length>1){
                    children[0].component = children[1].component
                    fullPath = m.children[0].path
                  }
                }
                let menu_name = m.menu_name
                if(lang=='en-US'||lang=='en'){
                  menu_name = m.en_name
                }
                const module = {
                  path: path,
                  component: layout,
                  meta: { id:m.id, title: menu_name, fullPath: fullPath},
                  children: children
                }
                menuRouters.push(module)
              }
            })

            // console.log('menuRouters', menuRouters)
            store.dispatch('setRouters', menuRouters)
            router.addRoutes(menuRouters)
            
            router.addRoutes( [{ path: '*', redirect: '/index' } ])
            next({ ...to, replace: true })
          })
        }
      }else{
        next('/login')
      }
    }
  })
})

router.afterEach((to,from) => {
  NProgress.done() // 结束Progress
  if(to.meta && to.meta.title){
    document.title = to.meta.title + ' | '+ store.state.system.title
  }else{
    document.title = store.state.system.title
  }
})

export default router
